import React from "react";

import FlagSprite from "./FlagSprite";
import Icon from "./Icon";

const LanguagePairingDropdown = ({ baseLanguageFlagIso, buttonClassName, languagePairings, targetLanguageFlagIso, targetLanguageName }) => {
  return (
    <div className="btn-group language-pairing-dropdown">
      <button type="button" className={buttonClassName || "btn btn-success-outline dropdown-toggle"} data-toggle="dropdown" style={buttonClassName ? {} : { background: "none", color: "#fff" }}>
        <FlagSprite flagIso={targetLanguageFlagIso} size={24} />
        <span className="tw-mr-5"><FlagSprite flagIso={baseLanguageFlagIso} size={24} /></span>
        <span className="joystix tw-hidden lg:tw-inline tw-mr-5 tw-align-middle">{targetLanguageName}</span>
        <span className="caret"></span>
      </button>
      <ul className="dropdown-menu dropdown-menu-right">
        {languagePairings.map((lp) => (
          <li key={lp.id} style={{ backgroundColor: lp.currentStreakIncludesToday ? "rgba(92, 184, 92, 0.2)" : null }}>
            <a href={`/l/${lp.slug}`}>
              <FlagSprite flagIso={lp.targetLanguageFlagIso} size={24} />
              <FlagSprite flagIso={lp.baseLanguageFlagIso} size={24} />
              <span className="tw-ml-5 tw-align-middle"><span className="tw-font-bold">{lp.targetLanguageName}</span> / {lp.baseLanguageName}</span>
              {!lp.showDaysPlayedInsteadOfStreak && <span className="tw-block joystix tw-text-base">Streak: <span className={lp.currentStreakIncludesToday ? "tw-color-streak-active" : ""}>{lp.currentStreakDays}</span> {lp.currentStreakIncludesToday && <Icon style={{ color: "#27bb4e" }} name="ok" />}</span>}
              {!!lp.showDaysPlayedInsteadOfStreak && <span className="tw-block joystix tw-text-base">Days Played: <span className={lp.currentStreakIncludesToday ? "tw-color-streak-active" : ""}>{lp.daysPlayedCount}</span> {lp.currentStreakIncludesToday && <Icon style={{ color: "#27bb4e" }} name="ok" />}</span>}
              <span className="tw-block joystix tw-text-base">Review: {lp.numReadyForReview.toLocaleString()}</span>
              <span className="tw-block joystix tw-text-base">{lp.dailyGoalPointsPerDay ? <>Daily Goal: <span className={lp.numPointsToday >= lp.dailyGoalPointsPerDay ? "tw-color-success" : ""}>{lp.numPointsToday}</span> / {lp.dailyGoalPointsPerDay}</> : <>Points today: {lp.numPointsToday}</>}</span>
            </a>
          </li>
        ))}
        <li style={{ margin: "10px 20px" }}><a className="btn btn-default joystix btn-block" href="/languages"><Icon name="plus" /> Language Pairing</a></li>
      </ul>
    </div>
  );
};

export default LanguagePairingDropdown;
